import React, { useState, useRef, useEffect } from 'react';
import ReactDOM from 'react-dom';

const SORT_OPTIONS = [
  { label: 'Price: Low to High', value: 'asc' },
  { label: 'Price: High to Low', value: 'desc' },
];

function SortDropdown({ currentSort, onSortChange }) {
  const [isOpen, setIsOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const buttonRef = useRef(null);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        buttonRef.current &&
        !buttonRef.current.contains(event.target) &&
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

//   const getCurrentLabel = () => {
//     return SORT_OPTIONS.find(option => option.value === currentSort)?.label || 'Sort By';
//   };

  const renderMobilePopup = () => {
    if (!isOpen || !isMobile) return null;

    const popup = (
      <div className="fixed inset-0 bg-black bg-opacity-50 z-[9999] flex items-end justify-center" onClick={() => setIsOpen(false)}>
        <div 
          className="w-full bg-white rounded-t-2xl shadow-2xl p-4 transform translate-y-0" 
          onClick={e => e.stopPropagation()}
          style={{ maxHeight: '80vh', overflowY: 'auto' }}
        >
          <div className="w-full max-w-sm mx-auto">
            <div className="w-12 h-1 bg-gray-300 rounded-full mx-auto mb-4"></div>
            <h3 className="text-lg font-medium mb-4">Sort By</h3>
            <div className="space-y-2">
              {SORT_OPTIONS.map((option) => (
                <label key={option.value} className="flex items-center space-x-2 p-2 hover:bg-gray-100 rounded">
                  <input
                    type="radio"
                    name="sort"
                    value={option.value}
                    checked={currentSort === option.value}
                    onChange={() => {
                      onSortChange(option.value);
                      setIsOpen(false);
                    }}
                    className="w-4 h-4"
                  />
                  <span className={`${currentSort === option.value ? 'font-medium text-black' : 'text-gray-600'}`}>
                    {option.label}
                  </span>
                </label>
              ))}
            </div>
          </div>
        </div>
      </div>
    );

    return ReactDOM.createPortal(popup, document.body);
  };

  const renderDesktopDropdown = () => {
    if (!isOpen || isMobile) return null;

    return (
      <div 
        ref={dropdownRef}
        className="absolute top-full left-0 mt-1 bg-white rounded-md shadow-lg py-1 min-w-[200px] z-50"
      >
        {SORT_OPTIONS.map((option) => (
          <button
            key={option.value}
            onClick={() => {
              onSortChange(option.value);
              setIsOpen(false);
            }}
            className={`w-full text-left px-4 py-2 hover:bg-gray-100 ${
              currentSort === option.value 
                ? 'bg-gray-100 border border-gray-300 font-medium text-black' 
                : 'text-gray-600'
            }`}
          >
            {option.label}
          </button>
        ))}
      </div>
    );
  };

  return (
    <div className="relative">
      <button
        ref={buttonRef}
        onClick={() => setIsOpen(!isOpen)}
        className="px-4 py-2 bg-gray-100 hover:bg-gray-200 rounded-md text-gray-700 flex items-center gap-2 active:bg-transparent focus:bg-transparent ring-0 focus:ring-0 active:ring-0 focus:outline-none active:outline-none"
        style={{ WebkitTapHighlightColor: 'transparent' }}
      >
        Sort
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>
      {renderDesktopDropdown()}
      {renderMobilePopup()}
    </div>
  );
}

export default SortDropdown; 